"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowGroupModel = void 0;
class RowGroupModel {
    isRowGroup;
    id;
    data;
    rows;
    constructor(group, rows) {
        this.id = group.id;
        this.data = group;
        this.rows = rows;
        this.isRowGroup = true;
    }
    static empty() {
        return new RowGroupModel({ id: '' }, []);
    }
}
exports.RowGroupModel = RowGroupModel;
//# sourceMappingURL=row-group-model.js.map